import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { ButtonBase, styled, Typography } from '@mui/material'
import {
  EVENT_CONFIG,
  FORUM_CONFIG,
  MULTIMEDIA_CONFIG,
  POST_CONFIG,
} from '$common/wapp-bar-theme'
import { WappIcon } from '../shared/wapp-icon'
import { showChatListToolboxOtherWappsModal } from '$comp/modals/chat-list-toolbox/chat-list-toolbox-other-wapps-modal.api'
import { showChatListToolboxCulturalContentsModal } from '$comp/modals/chat-list-toolbox/chat-list-toolbox-cultural-contents-modal.api'
import {
  openEventCreator,
  openForumCreator,
  openPostCreator,
} from '$logic/wapps/business'

export const otherWappsConfig = [
  {
    ...POST_CONFIG,
    onClick: openPostCreator,
    logoGradient: 'linear-gradient(60deg, #FA4545 13.4%, #F57073 86.6%)',
  },
  {
    ...MULTIMEDIA_CONFIG,
    logoGradient: 'linear-gradient(180deg, #9445EC 0%, #2782ED 100%)',
    onClick: () => {
      showChatListToolboxCulturalContentsModal({
        onBack: async () => {
          await closeCurrentModal()
          showChatListToolboxOtherWappsModal()
        },
      })
    },
  },
  {
    ...EVENT_CONFIG,
    onClick: openEventCreator,
    logoGradient: 'linear-gradient(147.25deg, #00B09B 0.82%, #96C93D 100.82%)',
  },
  {
    ...FORUM_CONFIG,
    onClick: openForumCreator,
    logoGradient: 'linear-gradient(180deg, #96C93D 0%, #00B09B 100.48%)',
  },
]

export function OtherWapps() {
  return (
    <>
      {otherWappsConfig.map(wappConfig => (
        <ListItem
          onClick={async () => {
            await closeCurrentModal()
            wappConfig.onClick()
          }}
        >
          <WappIcon
            background={wappConfig.logoGradient}
            icon={wappConfig.icon}
          />
          <Typography variant="subtitle3" color="neutral800">
            {wappConfig.name}
          </Typography>
        </ListItem>
      ))}
    </>
  )
}

const ListItem = styled(ButtonBase)`
  height: 56px;
  border-radius: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  justify-content: flex-start;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: ${({ theme }) => theme.palette.neutral100};
  }
`
